import { api, getAuthHeaders, post } from "../services.common";

export const registerForEventAPI = async (payload) => {
  let url = `${api}/event/registration`;
  let authHeader = getAuthHeaders();
  return await post(url, { ...payload }, { ...authHeader });
};
